module.exports = __webpack_public_path__ + "static/media/back5.057e06d0.jpg";